import type { GitRef, PlatformHubVersionControlSettingsResource, ValidateGitRefV2Response } from "@octopusdeploy/octopus-server-client";
import { ValidateGitRefV2ResponseType } from "@octopusdeploy/octopus-server-client";
import { links } from "@octopusdeploy/portal-routes";
import React from "react";
import { getBranchSelectorErrorMessage, VcsErrorInternal } from "~/areas/projects/components/VersionControl/VcsError";
import InternalLink from "~/components/Navigation/InternalLink";
import { PlatformHubPageHeaderBranchSelector } from "./PlatformHubPageHeaderBranchSelector";
interface PlatformHubVcsErrorProps {
    error: ValidateGitRefV2Response;
    gitRef: GitRef | undefined;
    persistenceSettings: PlatformHubVersionControlSettingsResource;
    setGitRef: (gitRef: string) => void;
}
export function PlatformHubVcsError({ error, gitRef, persistenceSettings, setGitRef }: PlatformHubVcsErrorProps) {
    const branchSelectorErrorMessage = getBranchSelectorErrorMessage(error);
    const branchSelector = <PlatformHubPageHeaderBranchSelector persistenceSettings={persistenceSettings} gitRef={gitRef} setGitRef={setGitRef} errorMessage={branchSelectorErrorMessage}/>;
    const errorInfoText = getErrorInfoText(error);
    const errorTitle = getErrorTitle(error);
    return <VcsErrorInternal errorTitle={errorTitle} error={error} branchSelector={branchSelector} errorInfoText={errorInfoText}/>;
}
function getErrorInfoText(error: ValidateGitRefV2Response) {
    switch (error.Type) {
        case ValidateGitRefV2ResponseType.ConnectionFailed:
            return (<>
                    This could be due to an outage, or your <InternalLink to={links.platformHubVersionControlSettingsPage.generateUrl()}>settings</InternalLink> might be incorrect.
                </>);
        default:
            return (<>
                    <span>Try selecting a different branch below</span>.
                </>);
    }
}
function getErrorTitle(error: ValidateGitRefV2Response): string {
    switch (error.Type) {
        case ValidateGitRefV2ResponseType.GitRefNotFound:
            return "Could not load the selected git ref";
        default:
            return "Could not connect to Git instance";
    }
}
